<template>
  <!-- 盘点单详情（新增/查看） -->
  <div class="stock-taking-detail">
    <list-page :status-name="dataDetail.statusName" :status-type="dataDetail.status === 2001? 'info': 'success'">
      <div class="form-div">
        <form-tag label="单据信息"/>
        <form-items :columns="3" :data="dataDetail">
          <form-item label="单据编号">
            <el-input v-model="dataDetail.billNo" placeholder="系统自动生成" disabled/>
          </form-item>
          <form-item label="盘点仓库" :required="true" name="warehouseId" error-message="请选择盘点仓库">
            <el-select v-model="dataDetail.warehouseId" placeholder="请选择盘点仓库" @change="warehouseChange">
              <el-option v-for="w in warehouseOptions" :key="w.id" :value="w.id" :label="w.warehouseName"/>
            </el-select>
          </form-item>
          <form-item label="单据日期">
            <el-date-picker v-model="dataDetail.billDate" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width:100%"/>
          </form-item>
          <form-item label="操作员">
            <el-input v-model="dataDetail.operatorName" disabled/>
          </form-item>
          <form-item label="部门">
            <depart-select v-model="dataDetail.departCode" :data="departTree" :disabled="isReadonly || dataDetail.status === 2" placeholder="请选择部门"/>
          </form-item>
          <form-item label="备注" :show-block="true">
            <el-input type="textarea" v-model="dataDetail.remark" placeholder="盘点说明"/>
          </form-item>
        </form-items>
        <form-tag label="盘点明细（系统自动对比当前库存与现有数量，反写数量变更与变更类型）"/>
      </div>
      <list-table class="list-table" background-color="#FFF">
        <product-select-table ref="itemTable" v-model="dataDetail.items" :multi="true" @table-select-multi="addList2Items">
          <yq-table-column label="批次" prop="batchNumber" width="150rem">
            <template v-slot="{row}">
              <span>{{row.batchNumber}}</span>
            </template>
          </yq-table-column>
          <yq-table-column label="单位" width="110rem" align="center">
            <template v-slot="{row}">
              <el-select v-model="row.skuUnitId" :disabled="isReadonly" placeholder="请选择单位" @change="rowQtyChange(row)" style="width:100%">
                <el-option v-for="u in row.units" :key="u" :value="u" :label="unitName(u)"/>
              </el-select>
            </template>
          </yq-table-column>
          <yq-table-column label="实盘数量" prop="skuQty" width="130rem">
            <template v-slot="{row}">
              <el-input-number v-model="row.skuQty" :min="0" controls-position="right" :disabled="isReadonly" style="width:100%" @change="rowQtyChange(row)"/>
            </template>
          </yq-table-column>
          <yq-table-column label="库存数量" prop="currentQty" width="110rem" align="right"/>
          <yq-table-column label="基本单位数量" prop="actualQty" width="130rem" align="right" />
          <yq-table-column label="数量变更" prop="changeQty" width="100rem" align="right">
            <template v-slot="{row}">
              <span :style="{color: Number(row.changeQty) >= 0 ? 'var(--el-color-success)' : 'var(--el-color-danger)'}">
                {{Number(row.changeQty) > 0 ? '+' : ''}}{{row.changeQty}}
              </span>
            </template>
          </yq-table-column>
          <yq-table-column label="变更类型" prop="changeType" width="110rem" align="center">
            <template v-slot="{row}">
              <el-tag v-if="Number(row.changeQty) > 0" size="small" type="success">盘点报溢</el-tag>
              <el-tag v-else-if="Number(row.changeQty) < 0" size="small" type="danger">盘点报损</el-tag>
              <span v-else class="muted">—</span>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" props="options" width="90rem" align="center" v-if="!isReadonly">
            <template v-slot="{row, $index}">
              <table-button el-type="danger" @click="deleteItem($index)">移除</table-button>
            </template>
            <template #header>
              <table-button :disabled="isReadonly" @click="addItem"><yq-icon name="element-ui_plus"/>添加商品</table-button>
            </template>
          </yq-table-column>
        </product-select-table>
      </list-table>

      <form-page :show-page="false" v-if="!isReadonly">
        <template #left>
          <div class="tip-info">
            💡 提交时自动生成三张单据（有则生成）：盘点单 + 报损出库单（数量=报损差额）+ 报溢入库单（数量=报溢差额），库存按差额自动调整。
          </div>
        </template>
        <page-button :disabled="dataDetail.status > 2001" type="write" el-type="primary" @click="saveData">保存草稿</page-button>
        <page-button :disabled="dataDetail.status > 2001" type="write" el-type="success" @click="submitData">提交单据</page-button>
        <page-button @click="router.go(-1)">取消</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import YqIcon from "@/components/YqIcon.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import ProductSelectTable from "@/components/h5/product/ProductSelectTable.vue";
import DepartSelect from "@/components/h5/data/DepartSelect.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import commonApi from "@/api/commonApi";
import stocktakeOrderApi from "@/api/normal/stock/stocktakeOrderApi";
import commonDataApi from "@/api/normal/common/commonDataApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "StockTakingDetail",
  components: {
    YqIcon, ProductSelectTable, YqTableColumn, TableButton, FormItems, FormItem, FormTag,
    DepartSelect,
    PageButton, ListPage, ListTable, FormPage
  },
  data() {
    return {
      warehouseOptions: [],
      departTree: [],
      unitList: [],
      userInfo: {},
      dataDetail: {},
      isReadonly: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    // 不使用页面缓存
    this.userInfo = await Util.getUserInfo();
    this.init();
    let id = this.route.query.id;
    if (id) {
      this.isReadonly = this.route.query.view === '1';
      this.findById(id);
    } else {
      this.initNew();
    }
  },
  methods: {
    init() {
      // 仓库：主部门唯一仓库自动选中
      commonDataApi.queryAllWarehouse().then(warehouses => {
        this.warehouseOptions = warehouses || [];
        if (this.warehouseOptions.length === 1) {
          this.dataDetail.warehouseId = this.warehouseOptions[0].id;
          return;
        }
        let count = 0;
        let warehouseId = "";
        for (let i = 0; i < this.warehouseOptions.length; i++) {
          if (this.userInfo.mainDepartCode === this.warehouseOptions[i].departCode) {
            count++;
            warehouseId = this.warehouseOptions[i].id;
          }
        }
        if (count === 1) {
          this.dataDetail.warehouseId = warehouseId;
        }
      });
      commonApi.queryDepartList().then(departs => this.departTree = departs || []);
      commonApi.queryUniqueDictionaryList("PRODUCT_UNIT").then(units => this.unitList = units || []);
    },
    unitName(unitId) {
      if (!unitId) return "";
      let u = this.unitList.find(it => it.dictCode === unitId);
      return u ? u.dictName : "";
    },
    async findById(id) {
      const res = await stocktakeOrderApi.findById(id);
      this.dataDetail = res;
      this.dataDetail.items = (res.itemList || []).map(it => ({
        skuId: it.skuId || it.productId,
        productId: it.productId,
        productName: it.productName || "",
        batchId: it.batchId,
        batchNumber: it.batchNumber,
        unitIdBase: it.unitIdBase || it.skuUnitId,
        unitIdMiddle: it.unitIdMiddle,
        unitIdLarge: it.unitIdLarge,
        skuUnitId: it.skuUnitId || it.unitIdBase,
        skuQty: it.skuQty != null ? it.skuQty : it.actualQty,
        currentQty: it.currentQty,
        actualQty: it.actualQty,
        changeQty: it.changeQty,
      }));
      this.dataDetail.items.forEach(r => {
        r.units = [r.unitIdBase, r.unitIdMiddle, r.unitIdLarge].filter(Boolean);
      });
    },
    initNew() {
      // 操作员/部门默认当前用户；仓库自动选中由 init 的 queryAllWarehouse 处理
      this.dataDetail = {
        billNo: "", warehouseId: this.dataDetail.warehouseId, billDate: this.today(), remark: "",
        operatorId: this.userInfo.id,
        operatorName: this.userInfo.employeeName,
        departCode: this.userInfo.mainDepartCode,
        items: [{}],
        status: 2001,
      };
    },
    today() {
      return new Date().toISOString().slice(0, 10);
    },
    async warehouseChange() {
      // 切换仓库后清空明细，重新添加商品时带出该仓库当前库存
      this.dataDetail.items = [];
    },
    async addItem() {
      if (!this.dataDetail.warehouseId) {
        this.$message.error("请先选择盘点仓库");
        return;
      }
      this.$refs.itemTable.toSelectMore();
    },
    async addList2Items(list) {
      await this.fillItems(this.dataDetail.items, list);
    },
    // 添加商品：调用 queryStockBatchVoByProducts 批量查询该商品在仓库的批次库存，多批次拆成多行
    async fillItems(items, list) {
      if (!this.dataDetail.warehouseId) {
        this.$message.error("请先选择盘点仓库");
        return;
      }
      const productIds = [];
      for (let j = 0; j < list.length; j++) {
        const productId = list[j].parentId || list[j].id;
        if (productIds.indexOf(productId) < 0) productIds.push(productId);
      }
      // 按商品批量查批次库存
      const batches = await stocktakeOrderApi.queryStockBatchVoByProducts(this.dataDetail.warehouseId, productIds);
      // 按商品分组批次
      const batchMap = {};
      (batches || []).forEach(b => {
        const key = b.productId || b.skuId;
        if (!batchMap[key]) batchMap[key] = [];
        batchMap[key].push(b);
      });
      const newItems = [];
      for (let i = 0; i < items.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (items[i].skuId === list[j].id) {
            const skuId = list[j].id;
            const productId = list[j].parentId || list[j].id;
            const productBatches = batchMap[productId] || [];
            if (productBatches.length === 0) {
              // 无库存批次，仅一行，当前库存为0
              const row = {
                skuId: skuId, productId: productId, productName: list[j].productName,
                unitIdBase: list[j].unitIdBase, unitIdMiddle: list[j].unitIdMiddle, unitIdLarge: list[j].unitIdLarge,
                middleRate: list[j].middleRate, largeRate: list[j].largeRate,
                units: [list[j].unitIdBase, list[j].unitIdMiddle, list[j].unitIdLarge].filter(Boolean),
                batchNumber: "", currentQty: 0, skuUnitId: list[j].unitIdBase,
                skuQty: 0, actualQty: 0, changeQty: 0,
              };
              newItems.push(row);
            } else {
              // 多批次拆成多行，每行带出该批次库存数量
              productBatches.forEach(b => {
                const row = {
                  skuId: skuId, productId: productId, productName: list[j].productName,
                  unitIdBase: b.unitIdBase || list[j].unitIdBase,
                  unitIdMiddle: list[j].unitIdMiddle, unitIdLarge: list[j].unitIdLarge,
                  middleRate: list[j].middleRate, largeRate: list[j].largeRate,
                  units: [b.unitIdBase || list[j].unitIdBase, list[j].unitIdMiddle, list[j].unitIdLarge].filter(Boolean),
                  batchId: b.batchId, batchNumber: b.batchNumber,
                  currentQty: Number(b.qty) || 0,
                  skuUnitId: b.unitIdBase || list[j].unitIdBase,
                  skuQty: Number(b.qty) || 0,
                  actualQty: Number(b.qty) || 0,
                  changeQty: 0,
                };
                newItems.push(row);
              });
            }
          }
        }
      }
      // 替换原明细行为拆分后的行
      this.dataDetail.items = newItems;
      this.$refs.itemTable.refresh();
    },
    // 换单位/实盘数量：按换算率把实盘数量(skuQty)转成基本单位数量(actualQty)
    rowQtyChange(row) {
      if (!row) return;
      let rate = 1;
      if (row.skuUnitId && row.skuUnitId === row.unitIdMiddle && row.middleRate) {
        rate = Number(row.middleRate);
      } else if (row.skuUnitId && row.skuUnitId === row.unitIdLarge && row.largeRate) {
        rate = Number(row.largeRate);
      }
      row.actualQty = Number(((Number(row.skuQty) || 0) * rate).toFixed(4));
      this.calcChange(row);
    },
    deleteItem(index) {
      this.dataDetail.items.splice(index, 1);
      this.$refs.itemTable.refresh();
    },
    calcChange(row) {
      row.changeQty = (Number(row.actualQty) || 0) - (Number(row.currentQty) || 0);
    },
    buildItemList() {
      return (this.dataDetail.items || []).filter(it => it.skuId).map(it => ({
        productId: it.productId || it.skuId,
        skuId: it.skuId,
        batchId: it.batchId,
        batchNumber: it.batchNumber,
        skuUnitId: it.skuUnitId,
        skuQty: it.skuQty,
        currentQty: it.currentQty,
        actualQty: it.actualQty,
        changeQty: it.changeQty,
      }));
    },
    validate() {
      if (!this.dataDetail.warehouseId) {
        this.$message.error("请选择盘点仓库");
        return false;
      }
      const items = this.buildItemList();
      if (items.length === 0) {
        this.$message.error("请添加盘点商品");
        return false;
      }
      return true;
    },
    saveData() {
      if (!this.validate()) return;
      const submitData = {...this.dataDetail, itemList: this.buildItemList()};
      submitData.status = 2001;
      stocktakeOrderApi.save(submitData).then(() => this.router.push('/stock/stockTaking'));
    },
    submitData() {
      if (!this.validate()) return;
      const submitData = {...this.dataDetail, itemList: this.buildItemList()};
      submitData.status = 2010;
      stocktakeOrderApi.save(submitData).then(() => this.router.push('/stock/stockTaking'));
    }
  }
};
</script>

<style lang="scss" scoped>
.stock-taking-detail {
  height: 100%;
  .form-div{
    padding: 10px 10px 0 10px;
    background: #FFF;
  }
  .list-table {
    padding: 10px;
  }
  .add-item-btn {
    border: 1.5px dashed var(--yq-border-color);
    border-radius: 6px;
    padding: 8px;
    text-align: center;
    color: var(--yq-font-color-tips);
    font-size: 13px;
    cursor: pointer;
    margin: 8px 16px;
    &:hover { color: var(--el-color-primary); border-color: var(--el-color-primary); }
  }
  .tip-info {
    font-size: 12px;
    color: var(--el-color-primary);
  }
  .muted { color: var(--yq-font-color-desc); font-size: 12px; }
}
</style>
